<div class="min-h-screen bg-gray-50">
  <app-header-nav></app-header-nav>

  <div class="max-w-md mx-auto mt-10 px-4">
    <div class="bg-white rounded-lg shadow-lg p-8 text-center">

      <ng-container *ngIf="state === 'checking'">
        <mat-spinner diameter="48" class="mx-auto"></mat-spinner>
        <h1 class="text-xl font-semibold mt-6">Confirming your payment…</h1>
        <p class="text-sm text-gray-600 mt-2">We are checking with the payment provider.</p>
      </ng-container>

      <ng-container *ngIf="state === 'paid'">
        <mat-icon class="!text-6xl !w-16 !h-16 text-green-600">check_circle</mat-icon>
        <h1 class="text-2xl font-bold mt-4">Payment received</h1>
        <p class="text-gray-700 mt-2">
          Your order is paid<span *ngIf="amount"> — {{ amount | currency }}</span> and has gone to the bar.
        </p>
        <p *ngIf="reference" class="text-xs text-gray-500 mt-2">Reference {{ reference }}</p>
      </ng-container>

      <ng-container *ngIf="state === 'pending'">
        <mat-icon class="!text-6xl !w-16 !h-16 text-amber-600">hourglass_top</mat-icon>
        <h1 class="text-2xl font-bold mt-4">Payment not confirmed yet</h1>
        <p class="text-gray-700 mt-2">
          The provider has not finished with it. Nothing has been charged twice —
          if it goes through, the bar will see it. Please check with the counter
          before ordering again.
        </p>
      </ng-container>

      <ng-container *ngIf="state === 'failed'">
        <mat-icon class="!text-6xl !w-16 !h-16 text-red-600">error_outline</mat-icon>
        <h1 class="text-2xl font-bold mt-4">Payment failed</h1>
        <p class="text-gray-700 mt-2">
          Your card was not charged. You can try again, or pay at the counter.
        </p>
      </ng-container>

      <ng-container *ngIf="state === 'cancelled'">
        <mat-icon class="!text-6xl !w-16 !h-16 text-gray-500">cancel</mat-icon>
        <h1 class="text-2xl font-bold mt-4">Payment cancelled</h1>
        <p class="text-gray-700 mt-2">
          Nothing was charged. Your order is still waiting to be paid — try
          again, or pay at the counter.
        </p>
      </ng-container>

      <ng-container *ngIf="state === 'unknown'">
        <mat-icon class="!text-6xl !w-16 !h-16 text-gray-500">help_outline</mat-icon>
        <h1 class="text-2xl font-bold mt-4">We could not confirm this payment</h1>
        <p class="text-gray-700 mt-2">
          Please check with the bar before paying again, so you are not charged twice.
        </p>
      </ng-container>

      <button mat-raised-button color="primary" class="w-full mt-8" (click)="backToBar()"
              *ngIf="state !== 'checking'">
        <mat-icon class="mr-2">arrow_back</mat-icon>
        Back to the bar
      </button>
    </div>
  </div>
</div>
